import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Scrolls the window (and body) to the top on every route change.
 * Placed inside <BrowserRouter> so useLocation works.
 */
export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Use "instant" so the jump feels snappy rather than animated on navigation
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    // Fallback for older browsers that ignore "instant"
    if (document.scrollingElement) {
      document.scrollingElement.scrollTop = 0;
    }
  }, [pathname]);

  return null;
}
